<script>
  export let sprite, width, offset, fullWidth, borderRadius, className;

  $: aspectRatio = sprite?.width / sprite?.height;
  $: _width = width || sprite?.width;
  $: _height = _width / aspectRatio;
  $: scale = 100 / (sprite.width / fullWidth);
  $: offsetX = offset[0] * (_width / sprite.width);
  $: offsetY = offset[1] * (_height / sprite.height);
</script>

<div
  class="component {sprite.class} {className}"
  style:border-radius="{borderRadius ? _width / borderRadius : 0}px"
  style:background-size="{scale}%"
  style:background-position="-{offsetX}px -{offsetY}px"
  style:width="{_width}px"
  style:height="{_height}px"
  {...$$props}
></div>

<style>
  .component {
    flex-shrink: 0;
  }

  .CRAFTING_TABLE {
    background-image: url("img/CraftingtreePieces.png");
  }
  .SKILLS {
    background-image: url("img/Skill_Icons.png");
  }

  .TOKENS {
    background-image: url("img/Tokens.jpg");
  }
</style>
